/** Distance kept from the window's edges. */
const MARGIN = 8;
/** Gap between the button and its list. */
const GAP = 4;

type Rect = { left: number; top: number; right: number; bottom: number };
/** The visible part of the window (the visual viewport when there is one). */
type View = { left: number; top: number; width: number; height: number };
export type MenuPlace = { left: number; top: number; maxHeight: number | undefined };

/**
 * Where a „⋯” list goes, in window (fixed) coordinates (owner 2026-11-01: the invoices' „⋯” ran off the window).
 * Horizontally on the `prefer`red side of the button ("end": right edges in line, the list to the left; "start": left
 * edges in line), flipped when it does not fit, clamped `MARGIN` from the edges. Vertically below the button, above it
 * when the room below is short; when neither fits, on the roomier side with a `maxHeight` (the list scrolls).
 */
export function placeMenu(anchor: Rect, menu: { width: number; height: number }, view: View, prefer: 'start' | 'end'): MenuPlace {
  const minX = view.left + MARGIN;
  const maxX = view.left + view.width - MARGIN - menu.width;
  const atStart = anchor.left;
  const atEnd = anchor.right - menu.width;
  const fits = (x: number) => x >= minX && x <= maxX;
  const [first, second] = prefer === 'start' ? [atStart, atEnd] : [atEnd, atStart];
  const left = fits(first) ? first : fits(second) ? second : maxX < minX ? minX : Math.min(Math.max(first, minX), maxX);

  const viewBottom = view.top + view.height - MARGIN;
  const belowTop = anchor.bottom + GAP;
  const below = viewBottom - belowTop;
  const above = anchor.top - GAP - (view.top + MARGIN);
  if (menu.height <= below) return { left, top: belowTop, maxHeight: undefined };
  if (menu.height <= above) return { left, top: anchor.top - GAP - menu.height, maxHeight: undefined };
  if (below >= above) return { left, top: belowTop, maxHeight: Math.max(below, 0) };
  return { left, top: view.top + MARGIN, maxHeight: Math.max(above, 0) };
}
